import { render, staticRenderFns } from "./SipAccountCreate.vue?vue&type=template&id=683c9970&scoped=true&"
import script from "./SipAccountCreate.vue?vue&type=script&lang=js&"
export * from "./SipAccountCreate.vue?vue&type=script&lang=js&"
import style0 from "./SipAccountCreate.vue?vue&type=style&index=0&id=683c9970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c9970",
  null
  
)

/* custom blocks */
import block0 from "./SipAccountCreate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports